import { EAgentTypes } from '../enums/EAgentTypes';

export const WORK_HONESTLY_MESSAGES: { [key in EAgentTypes]: string } = {
  [EAgentTypes.Agency]: 'Документы агентства проверены',
  [EAgentTypes.Company]: 'Документы компании проверены',
  [EAgentTypes.Agent]: 'Документы агента проверены',
};
